module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fi":{"debtDescription":"Velkakuvaus","interestPercent":"Viiv. korko %","interestAmount":"Viiv. korko €"},"se":{"debtDescription":"Skuldbeskrivning","interestPercent":"Förs. ränta %","interestAmount":"Förs. ränta €"},"en":{"debtDescription":"Debt description","interestPercent":"Pen. int. %","interestAmount":"Pen. int. €"}}')
  delete Component.options._Ctor
}
